var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6204 5.66344C0.0961349 5.9118 0.13209 6.66564 0.677405 6.86228L4.21144 8.13574C4.31131 8.17169 4.4192 8.1797 4.52339 8.1589C4.62759 8.1381 4.72409 8.08928 4.80241 8.01776L8.24673 4.8742C8.42826 4.70885 8.70282 4.92222 8.58535 5.13736L6.35064 9.22062C6.29978 9.31349 6.27547 9.41841 6.28035 9.52398C6.28524 9.62956 6.31913 9.73174 6.37834 9.81942L8.47645 12.9234C8.80016 13.4026 9.54458 13.2548 9.66022 12.6889L11.9558 1.4472C12.0629 0.921627 11.5214 0.500739 11.0347 0.731316L0.6204 5.66344Z",
    fill: "#A371FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.8ba12475a81e8db3b59d8d0cf14e9d00.svg";
export { ForwardRef as ReactComponent };